const signs = {
  ' ': '-',
  '.': '-',
  '_': '-',
  'ą': 'a',
  'ę': 'e',
  'ś': 's',
  'ć': 'c',
  'ó': 'o',
  'ń': 'n',
  'ż': 'z',
  'ź': 'z',
  'ł': 'l'
};

const resolveUrl = (baseUrl, ...otherUrls) => {
  if (!baseUrl && !otherUrls.length) {
    return '';
  }

  const data = baseUrl 
    ? baseUrl.split('/').filter((url) => url && url !== '/')
    : [];

  for (const url of otherUrls) {
    if (url && !data[data.length - 1]?.endsWith(url)) {
      data.push(url);
    }
  }

  return `/${data.join('/')}/`
    .toLowerCase()
    .replace(/[_ąęśćóńźżł.\s]/g, (match) => signs[match] || '')
    .replace(/-+/g, '-')
    .replace(/\/+/g, '/');
}

module.exports = resolveUrl;
